// extracted by mini-css-extract-plugin
export default {"blogSingleItemContainer":"Blogs_blogSingleItemContainer__rkl8Q","blogSingleItem":"Blogs_blogSingleItem__STHmC"};